module.exports = __webpack_public_path__ + "media/images/logos/logo-edone-email-white-7dff8aa163f0e3a5cc85e3e2eb6a8032.png";